/* SHARKER · «¿Qué te llevas?», el interrogatorio de Sharky (06-10-2026). Marcado y estilos: snippets/shk-interrogatorio.liquid
   Portada: ¿para quién? → ¿qué? → ¿talla? → 3 prendas con stock real en esa talla.
   Ficha: ¿talla? → 3 prendas de otra familia que combinan con la que se está viendo.
   Las prendas se leen de /collections/<handle>/products.json, en el orden manual de cada colección. */
(function () {
  'use strict';
  var D = document, W = window;
  var RM = !!(W.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var TALLAS = ['S', 'M', 'L', 'XL', 'XXL'];
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function euros(n) { return '€' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',').replace(/,00$/, ''); }

  var cache = {};
  function coleccion(h) {
    if (!cache[h]) {
      cache[h] = fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=60', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('colección ' + h); return r.json(); })
        .then(function (j) { return j.products || []; });
      cache[h].catch(function () { delete cache[h]; });
    }
    return cache[h];
  }
  /* ¿La prenda va por tallas S-XXL? (las fundas y gorras no: «Talla única», «IPHONE 14»…) */
  function porTallas(p) {
    return (p.variants || []).some(function (v) { return [v.option1, v.option2, v.option3].some(function (o) { return o && TALLAS.indexOf(String(o).toUpperCase()) > -1; }); });
  }
  function enTalla(p, talla) {
    return (p.variants || []).filter(function (v) {
      return v.available && [v.option1, v.option2, v.option3].some(function (o) { return o && String(o).toUpperCase() === talla; });
    })[0] || null;
  }
  /* Hasta n prendas, alternando entre colecciones, sin repetir y sin la que ya se está viendo */
  function elige(cols, talla, n, excluye) {
    return Promise.all(cols.map(coleccion)).then(function (listas) {
      var vistos = {}, out = [], max = Math.max.apply(null, listas.map(function (l) { return l.length; }).concat(0));
      for (var i = 0; i < max && out.length < n; i++) {
        listas.forEach(function (l) {
          var p = l[i];
          if (!p || out.length >= n || vistos[p.handle] || p.handle === excluye || p.handle === 'prueba') return;
          vistos[p.handle] = 1;
          var libres = (p.variants || []).filter(function (x) { return x.available; });
          if (!libres.length) return;
          var v;
          if (talla && porTallas(p)) { v = enTalla(p, talla); if (!v) return; }
          else v = libres.length === 1 ? libres[0] : { elegir: true, price: libres[0].price, compare_at_price: libres[0].compare_at_price };
          out.push({ p: p, v: v, talla: talla && porTallas(p) ? talla : '' });
        });
      }
      return out;
    });
  }
  function tarjetas(lista) {
    return '<div class="shk-int__res">' + lista.map(function (x) {
      var p = x.p, v = x.v, img = p.images && p.images[0] ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      var precio = parseFloat(v.price) || 0, antes = parseFloat(v.compare_at_price || 0) || 0;
      var url = '/products/' + p.handle + (v.id ? '?variant=' + v.id : '');
      var boton = v.elegir
        ? '<a class="shk-int__add" href="' + esc(url) + '">Elegir modelo</a>'
        : '<button type="button" class="shk-int__add" data-v="' + v.id + '" data-t="' + esc(p.title) + '" data-ta="' + esc(x.talla) + '" data-p="' + Math.round(precio * 100) + '" data-f="' + esc(img) + '">Añadir' + (x.talla ? ' · ' + esc(x.talla) : '') + '</button>';
      return '<div class="shk-int__it"><a href="' + esc(url) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="500"></a>' +
        '<span class="shk-int__n">' + esc(p.title) + '</span>' +
        '<span class="shk-int__p">' + euros(precio) + (antes > precio ? '<s>' + euros(antes) + '</s>' : '') + '</span>' + boton + '</div>';
    }).join('') + '</div>';
  }
  function anade(btn) {
    if (btn.disabled) return;
    var txt = btn.textContent; btn.disabled = true; btn.textContent = 'En la bolsa ✓'; btn.classList.add('is-ok');
    /* El carrito se abre ya con la prenda; Shopify confirma por detrás (assets/shk-cine.js) */
    if (typeof W.shkCartProvisional === 'function') {
      W.shkCartProvisional({ titulo: btn.getAttribute('data-t') || '', talla: btn.getAttribute('data-ta') || '', precio: +btn.getAttribute('data-p') || 0, cant: 1, foto: btn.getAttribute('data-f') || '' });
    }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-v'), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        D.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: '', quantity: 1 } }));
      })
      .catch(function (e) {
        var desc = (e && (e.description || e.message)) || '';
        btn.classList.remove('is-ok');
        btn.textContent = /agotad|sold out|disponible|unavailable/i.test(desc) ? 'Agotada' : txt;
        btn.disabled = /agotad|sold out|disponible|unavailable/i.test(desc);
      });
  }

  function monta(box) {
    if (box.__shk) return; box.__shk = true;
    var caja = $('.shk-int__caja', box), prog = $$('.shk-int__prog i', box), ficha = box.getAttribute('data-modo') === 'ficha', resp = {};
    function paso(i) { prog.forEach(function (p, k) { p.classList.toggle('on', k < i); }); }
    function pinta(pregunta, ops, cb, nota) {
      caja.classList.remove('is-in'); void caja.offsetWidth; if (!RM) caja.classList.add('is-in');
      caja.innerHTML = '<p class="shk-int__q">' + esc(pregunta) + '</p>' + (nota ? '<p class="shk-int__nota">' + esc(nota) + '</p>' : '') +
        '<div class="shk-int__ops">' + ops.map(function (o) { return '<button type="button" data-v="' + esc(o[0]) + '"' + (o[2] ? ' class="' + o[2] + '"' : '') + '>' + esc(o[1]) + '</button>'; }).join('') + '</div>';
      $$('.shk-int__ops button', caja).forEach(function (b) { b.addEventListener('click', function () { cb(b.getAttribute('data-v')); }); });
    }
    function otraVez(alPulsar) { var b = $('[data-otra]', caja); if (b) b.addEventListener('click', alPulsar); }
    function busca(cols, talla, cabecera, nota, alRepetir) {
      paso(3);
      caja.innerHTML = '<p class="shk-int__q">Sharky está buscando en el almacén<span class="shk-int__pts">…</span></p>';
      elige(cols, talla, 3, box.getAttribute('data-actual') || '').then(function (lista) {
        if (!lista.length) {
          caja.innerHTML = '<p class="shk-int__q">' + (talla ? 'En la ' + esc(talla) + ' no queda nada de esto.' : 'Ahora mismo no queda nada de esto.') + ' ¿Probamos otra cosa?</p><div class="shk-int__ops"><button type="button" data-otra>OTRA VEZ</button></div>';
          otraVez(alRepetir); return;
        }
        caja.innerHTML = '<p class="shk-int__q">' + esc(cabecera) + '</p>' + (nota ? '<p class="shk-int__nota">' + esc(nota) + '</p>' : '') + tarjetas(lista) +
          '<div class="shk-int__ops"><button type="button" data-otra class="sec">' + (ficha ? 'OTRA TALLA' : 'OTRA VEZ') + '</button></div>';
        $$('.shk-int__add[data-v]', caja).forEach(function (b) { b.addEventListener('click', function () { anade(b); }); });
        otraVez(alRepetir);
      }).catch(function () {
        caja.innerHTML = '<p class="shk-int__q">No he podido mirar el almacén. Prueba otra vez.</p><div class="shk-int__ops"><button type="button" data-otra>OTRA VEZ</button></div>';
        otraVez(alRepetir);
      });
    }

    /* ---- Portada: tres preguntas ---- */
    function p1() { resp = {}; paso(0); pinta('¿Para quién es?', [['yo', 'Para mí'], ['regalo', 'Es un regalo']], function (v) { resp.para = v; p2(); }); }
    function p2() {
      paso(1);
      pinta('¿Qué te apetece?', [['sudadera', 'Sudadera'], ['camiseta', 'Camiseta'], ['halfzip', 'Half zip'], ['accesorio', 'Accesorio']],
        function (v) { resp.que = v; if (v === 'accesorio') { resp.talla = ''; fin(); } else p3(); },
        resp.para === 'regalo' ? 'Buen plan. Sharky es experto en regalos.' : 'Buena respuesta.');
    }
    function p3() {
      paso(2);
      var ops = TALLAS.map(function (t) { return [t, t]; });
      if (resp.para === 'regalo') ops.push(['?', 'No lo sé']);
      pinta(resp.para === 'regalo' ? '¿Qué talla usa?' : '¿Qué talla usas?', ops, function (v) { resp.talla = v; fin(); });
    }
    function fin() {
      var col = box.getAttribute('data-col-' + resp.que) || 'camisetas', talla = resp.talla === '?' ? 'M' : resp.talla;
      busca([col], talla, resp.para === 'regalo' ? 'Le va a encantar:' : 'Esto es lo tuyo:',
        resp.talla === '?' ? 'Te ponemos la M. Si no acierta, tiene 30 días para cambiarla.' : '', p1);
    }

    /* ---- Ficha: solo la talla ---- */
    function tallaFicha() {
      var form = $('.Product__Info form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
      var marcada = form && $('input[name^="option-"]:checked', form);
      var actual = marcada ? String(marcada.value).toUpperCase() : '';
      pinta('¿Qué talla usas?', TALLAS.map(function (t) { return [t, t, t === actual ? 'is-sug' : '']; }), function (v) {
        var cols = (box.getAttribute('data-combina') || 'camisetas').split(',');
        busca(cols, v, 'Van genial con esta:', '', tallaFicha);
      });
    }

    var go = $('.shk-int__go', box);
    if (go) go.addEventListener('click', ficha ? tallaFicha : p1);
  }

  function adelanta(box) {
    var cols = (box.getAttribute('data-combina') || '').split(',').filter(Boolean);
    if (!cols.length) cols = ['sudadera', 'camiseta', 'halfzip', 'accesorio'].map(function (k) { return box.getAttribute('data-col-' + k); }).filter(Boolean);
    cols.forEach(function (h) { coleccion(h).catch(function () {}); });
  }
  function arranca() {
    $$('[data-shk-int]').forEach(function (box) {
      monta(box);
      if (!('IntersectionObserver' in W) || (navigator.connection && navigator.connection.saveData)) return;
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); adelanta(box); } }, { rootMargin: '600px 0px' });
      io.observe(box);
    });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
